import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-suivi-demande-adhesion',
  templateUrl: './suivi-demande-adhesion.component.html',
  styleUrls: ['./suivi-demande-adhesion.component.scss']
})
export class SuiviDemandeAdhesionComponent implements OnInit {

  configuration = this.configurationService.get();
  constructor(private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

}
